var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Tracker from "./tracker";
import LocalStorage from "./localStorage";
var Conversion = /** @class */ (function (_super) {
    __extends(Conversion, _super);
    function Conversion(parameters, experiment) {
        var _this = _super.call(this) || this;
        _this.dataType = parameters.dataType;
        _this.oneOff = parameters.oneOff;
        _this.type = parameters.type;
        _this.pageTarget = parameters.pageTarget;
        _this.pageTargetCondition = parameters.pageTargetCondition;
        _this.timeOnPage = parameters.timeOnPage;
        _this.scrollDepth = parameters.scrollDepth;
        _this.element = parameters.element;
        _this.elementType = parameters.elementType || 'id';
        _this.container = parameters.container;
        _this.experiment = experiment;
        _this.storage = new LocalStorage();
        return _this;
    }
    Conversion.prototype.shouldConvert = function () {
        var alreadyConverted = this.storage.get(this.experiment.parameters.name, 'converted');
        if (alreadyConverted && this.oneOff) {
            return false;
        }
        return true;
    };
    Conversion.prototype.sendConversion = function () {
        return __awaiter(this, void 0, void 0, function () {
            var variant;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.shouldConvert())
                            return [2 /*return*/];
                        // Ensure tracker has storage context for token header + persistence
                        this.attachStorage(this.storage, this.experiment.parameters.name);
                        variant = this.experiment.parameters.isExternal
                            ? (function () {
                                var _a;
                                var param = new URLSearchParams(window.location.search).get('ab_variant');
                                if (!param)
                                    return undefined;
                                return (_a = _this.experiment.parameters.variants.find(function (v) { return v.name === param; })) === null || _a === void 0 ? void 0 : _a.id;
                            })()
                            : ((_a = this.experiment.variantId) !== null && _a !== void 0 ? _a : Number.NaN);
                        if (!variant) return [3 /*break*/, 2];
                        this.storage.set(this.experiment.parameters.name, 'converted', true);
                        return [4 /*yield*/, this.sendEvent({
                                type: 'conversion',
                                variant: variant,
                                abtest: this.experiment.parameters.uuid,
                            })];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    Conversion.prototype.containerClickListener = function (event) {
        var target = event.target;
        if (!this.element || !target) {
            return;
        }
        if (this.elementType === 'class') {
            if (target.classList.contains(this.element)) {
                this.sendConversion();
            }
        }
    };
    Conversion.prototype.enable = function () {
        var _this = this;
        var _a, _b;
        switch (this.type) {
            case "click":
                if (this.container) {
                    var container = document.getElementById(this.container);
                    container === null || container === void 0 ? void 0 : container.addEventListener('click', this.containerClickListener.bind(this));
                }
                else {
                    if (this.element) {
                        if (this.elementType === 'id') {
                            (_a = document.getElementById(this.element)) === null || _a === void 0 ? void 0 : _a.addEventListener('click', this.sendConversion.bind(this));
                        }
                        else {
                            var elements = document.querySelectorAll(".".concat(this.element));
                            elements.forEach(function (e) {
                                e.addEventListener('click', _this.sendConversion.bind(_this));
                            });
                        }
                    }
                }
                break;
            case "form_submission":
                if (this.element) {
                    var container = this.container ? document.getElementById(this.container) : document;
                    if (this.elementType === 'class') {
                        var elements = container === null || container === void 0 ? void 0 : container.querySelectorAll(".".concat(this.element));
                        elements === null || elements === void 0 ? void 0 : elements.forEach(function (e) {
                            e.addEventListener('submit', _this.sendConversion.bind(_this));
                        });
                    }
                    else {
                        (_b = document.getElementById(this.element)) === null || _b === void 0 ? void 0 : _b.addEventListener('submit', this.sendConversion.bind(this));
                    }
                }
                break;
            case "page_view":
                if (!this.pageTarget)
                    return;
                var isSPA = !!window.detail;
                var currentUrl = !isSPA ? location.pathname : window.detail.path;
                if (!currentUrl)
                    break;
                if (!this._checkForTarget(currentUrl, this.pageTarget, this.pageTargetCondition))
                    break;
                // If the experiment is external, send immediatelly
                if (this.experiment.parameters.isExternal) {
                    this.sendConversion();
                }
                var referrer = '';
                if (!isSPA) {
                    if (document.referrer) {
                        try {
                            referrer = new URL(document.referrer).pathname;
                        }
                        catch (_c) {
                            // Ignore invalid referrer
                        }
                    }
                }
                else {
                    referrer = window.detail.prevPath;
                }
                if (!referrer)
                    break;
                // otherwise check that the user navigates from any experiment target page
                for (var _i = 0, _d = this.experiment.parameters.targets; _i < _d.length; _i++) {
                    var target = _d[_i];
                    if (this._checkForTarget(referrer, target, this.experiment.parameters.targetCondition)) {
                        this.sendConversion();
                        break;
                    }
                }
                break;
            case "time_on_page":
                if (this.timeOnPage) {
                    var timerID_1 = undefined;
                    var handlePageFocus_1 = function () {
                        if (!_this.shouldConvert()) {
                            console.log('Clearing listeners');
                            window.removeEventListener('focus', handlePageFocus_1);
                            window.removeEventListener('blur', handlePageFocus_1);
                        }
                        if (document.hidden || !document.hasFocus()) {
                            if (!timerID_1)
                                return;
                            console.log('Stopping timer');
                            _this._clearTimer(timerID_1);
                            timerID_1 = undefined;
                        }
                        else {
                            if (timerID_1)
                                return;
                            console.log('Starting timer');
                            timerID_1 = _this._startTimer(_this.timeOnPage, _this.sendConversion.bind(_this));
                        }
                    };
                    window.addEventListener('focus', handlePageFocus_1);
                    window.addEventListener('blur', handlePageFocus_1);
                }
                break;
            case "scroll_depth":
                if (this.scrollDepth) {
                    var clientHeight_1 = document.documentElement.clientHeight;
                    var pageHeight_1 = document.documentElement.scrollHeight;
                    window.addEventListener('scroll', function () {
                        var scrollTop = window.scrollY;
                        var scrollPercent = ((scrollTop + clientHeight_1) / pageHeight_1) * 100;
                        if (_this.scrollDepth && (scrollPercent >= _this.scrollDepth)) {
                            return _this.sendConversion.bind(_this)();
                        }
                    });
                }
                break;
            case "custom":
                // TODO
                break;
            default:
                break;
        }
    };
    Conversion.prototype._startTimer = function (minutes, callback) {
        if (!minutes || !callback)
            return;
        return setTimeout(function () {
            callback();
        }, minutes * 60 * 1000);
    };
    Conversion.prototype._clearTimer = function (timerID) {
        if (!timerID)
            return;
        clearTimeout(timerID);
    };
    Conversion.prototype._checkForTarget = function (currentUrl, target, targetCondition) {
        if (!target)
            return false; // no gating when empty
        switch (targetCondition) {
            case 'starts_with':
                if (currentUrl.startsWith(target)) {
                    return true;
                }
                break;
            case 'ends_with':
                if (currentUrl.endsWith(target)) {
                    return true;
                }
                break;
            case 'contains':
                if (currentUrl.includes(target)) {
                    return true;
                }
                break;
            case 'matches':
                var re = void 0;
                try {
                    re = new RegExp(target);
                }
                catch (_) {
                    return false;
                }
                if (re.test(currentUrl)) {
                    return true;
                }
                break;
            default:
                if (currentUrl == target) {
                    return true;
                }
                break;
        }
        return false;
    };
    return Conversion;
}(Tracker));
export default Conversion;
